import { ActivityReminderForm } from '@/features/activity-reminder/activity-reminder-form/activity-reminder-form'
import { useGetActivityReminderQuery } from '@/features/activity-reminder/use-get-activity-reminder-query'
import { TertiaryPageLayout } from '@/routes/-tertiary-page-layout'
import { useLingui } from '@lingui/react/macro'
import { createFileRoute } from '@tanstack/react-router'
import { CircleLoadingAnimation } from '@vgw/multibrand-fe-circle-loading-animation'
import { useToast } from 'packages/toast/src/toast-provider'
import { useEffect } from 'react'

export const Route = createFileRoute(
  '/_app/your-play/activity-reminder/set-reminder',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useLingui()
  const { show } = useToast()

  const {
    data: activityReminder,
    error,
    isPending,
  } = useGetActivityReminderQuery()

  useEffect(() => {
    if (error) {
      show({
        description: t`Something went wrong.`,
        variant: 'warning',
        close: false,
      })
    }
  }, [error, show, t])

  return (
    <TertiaryPageLayout headerText={t`Manage your playtime`}>
      {isPending ? (
        <CircleLoadingAnimation className="mt-[60px] w-full" />
      ) : (
        <ActivityReminderForm activityReminder={activityReminder} />
      )}
    </TertiaryPageLayout>
  )
}
